import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BdStructuredDataService {
  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _document = inject<Document>(DOCUMENT);

  private _scriptElement: HTMLScriptElement | null = null;

  constructor() {
    this._listenToRouteChanges();
  }

  setStructuredData(data: Record<string, unknown>): void {
    if (!this._scriptElement) {
      this._scriptElement = this._document.createElement('script');
      this._scriptElement.setAttribute('type', 'application/ld+json');
      this._document.head.appendChild(this._scriptElement);
    }
    this._scriptElement.textContent = JSON.stringify(data);
  }

  removeStructuredData(): void {
    if (this._scriptElement) {
      this._scriptElement.remove();
      this._scriptElement = null;
    }
  }

  private _listenToRouteChanges(): void {
    this._router.events
      .pipe(
        filter(
          (event): event is NavigationStart =>
            event instanceof NavigationStart,
        ),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => {
        this.removeStructuredData();
      });
  }
}
